const productsOnPage = document.getElementById('product-grid');
const nextUrlEl = document.getElementById('paginateNext');
let nextUrl = nextUrlEl ? nextUrlEl.dataset.nextUrl : null;

const loadMoreBtn = document.getElementsByClassName('load-more_btn')[0];
const loadMoreSpinner = document.getElementsByClassName('load-more_spinner')[0];
const productBundleBuffer = [];
const productNodeIdPattern = /^(drawer-overlay|product-drawer|included-info-modal|islandModal)-(.+)$/;
const defaultBatchSize = 3;
let isLoadingMore = false;

function getConfiguredCount(attrName, fallback) {
  if (!productsOnPage) return fallback;
  const rawValue = Number.parseInt(productsOnPage.dataset[attrName] || '', 10);
  if (Number.isFinite(rawValue) && rawValue > 0) return rawValue;
  return fallback;
}

function getBatchSize() {
  return getConfiguredCount('batchSize', defaultBatchSize);
}

function getInitialBatchSize() {
  return getConfiguredCount('initialBatch', getBatchSize());
}

function getVisibleCardCount() {
  if (!productsOnPage) return 0;
  return productsOnPage.querySelectorAll('.plot-card').length;
}

function showLoadMoreButton() {
  if (loadMoreBtn && (nextUrl || productBundleBuffer.length > 0)) {
    loadMoreBtn.style.display = 'inline-flex';
  }
}

function hideLoadMoreButton() {
  if (loadMoreBtn) {
    loadMoreBtn.style.display = 'none';
  }
}

function showSpinner() {
  if (loadMoreSpinner) {
    loadMoreSpinner.style.display = 'block';
  }
}

function hideSpinner() {
  if (loadMoreSpinner) {
    loadMoreSpinner.style.display = 'none';
  }
}

async function getNextPage() {
  try {
    const res = await fetch(nextUrl);
    return await res.text();
  } catch (error) {
    console.error('Error fetching next page:', error);
    return null;
  }
}

function extractProductIdFromElement(el) {
  if (!el) return null;
  if (el.classList && el.classList.contains('plot-card')) {
    return el.getAttribute('data-product-id');
  }

  const id = el.id || '';
  const match = id.match(productNodeIdPattern);
  return match ? match[2] : null;
}

function collectProductBundles(productGrid) {
  const bundleOrder = [];
  const bundleMap = new Map();
  const nodes = Array.from(productGrid.childNodes);

  nodes.forEach((node) => {
    if (node.nodeType !== 1) return;
    const el = node;
    const productId = extractProductIdFromElement(el);
    if (!productId) return;

    if (!bundleMap.has(productId)) {
      bundleMap.set(productId, []);
      bundleOrder.push(productId);
    }

    bundleMap.get(productId).push(el);
  });

  return bundleOrder.map((productId) => ({
    productId,
    nodes: bundleMap.get(productId)
  }));
}

function appendBundle(bundle) {
  if (!bundle || !bundle.nodes || !productsOnPage) return;
  bundle.nodes.forEach((node) => {
    productsOnPage.appendChild(node);
  });

  if (typeof window.removeLegacyCollectionDrawers === 'function') {
    window.removeLegacyCollectionDrawers(productsOnPage);
  }
}

function appendFromBuffer(limit) {
  let appended = 0;
  while (productBundleBuffer.length > 0 && appended < limit) {
    const bundle = productBundleBuffer.shift();
    appendBundle(bundle);
    appended += 1;
  }
  return appended;
}

function appendRuntimeAssetsIfNeeded(nextPageDoc, productGrid) {
  // If runtime functions are already present, skip.
  if (window.__oasisDrawerRuntimeLoaded) return;
  if (typeof window.openDrawer === 'function') {
    window.__oasisDrawerRuntimeLoaded = true;
    return;
  }

  const candidates = Array.from(productGrid.childNodes).filter((node) => node.nodeType === 1);
  candidates.forEach((el) => {
    const tag = el.tagName;
    if (tag === 'STYLE') {
      const style = document.createElement('style');
      style.textContent = el.textContent || '';
      document.head.appendChild(style);
      return;
    }

    if (tag === 'SCRIPT') {
      const script = document.createElement('script');
      for (const attr of el.attributes) {
        script.setAttribute(attr.name, attr.value);
      }
      if (el.src) {
        script.src = el.src;
      } else {
        script.textContent = el.textContent || '';
      }
      document.body.appendChild(script);
      return;
    }

    if ((el.id === 'paymentCalcModal' || el.id === 'videoModal') && !document.getElementById(el.id)) {
      document.body.appendChild(el);
    }
  });

  window.__oasisDrawerRuntimeLoaded = typeof window.openDrawer === 'function';
}

async function queueNextPageBundles() {
  if (!nextUrl) return 0;

  const nextPage = await getNextPage();
  if (!nextPage) {
    nextUrl = null;
    return 0;
  }

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
  const productGrid = nextPageDoc.getElementById('product-grid');

  const newUrlElement = nextPageDoc.getElementById('paginateNext');
  nextUrl = newUrlElement && newUrlElement.dataset.nextUrl ? newUrlElement.dataset.nextUrl : null;

  if (!productGrid) return 0;

  appendRuntimeAssetsIfNeeded(nextPageDoc, productGrid);

  const bundles = collectProductBundles(productGrid);
  if (bundles.length > 0) {
    bundles.forEach((bundle) => productBundleBuffer.push(bundle));
  }
  return bundles.length;
}

function updateLoadMoreButtonState() {
  if (nextUrl || productBundleBuffer.length > 0) {
    showLoadMoreButton();
  } else {
    hideLoadMoreButton();
  }
}

async function appendTargetCards(targetCount) {
  let appended = 0;
  let attempts = 0;
  const maxFetchAttempts = 20;

  appended += appendFromBuffer(targetCount);

  while (appended < targetCount && (nextUrl || productBundleBuffer.length > 0) && attempts < maxFetchAttempts) {
    if (productBundleBuffer.length === 0 && nextUrl) {
      attempts += 1;
      await queueNextPageBundles();
    }

    if (productBundleBuffer.length === 0) {
      if (!nextUrl) break;
      continue;
    }

    appended += appendFromBuffer(targetCount - appended);
  }

  return appended;
}

async function runLoad(targetCount) {
  if (targetCount <= 0) {
    updateLoadMoreButtonState();
    return false;
  }
  if (isLoadingMore || !productsOnPage) return false;

  isLoadingMore = true;
  hideLoadMoreButton();
  showSpinner();

  try {
    const appended = await appendTargetCards(targetCount);
    if (appended > 0 && typeof initAllSliders === 'function') {
      initAllSliders();
    }
    return appended > 0;
  } catch (error) {
    console.error('Error loading more products:', error);
    return false;
  } finally {
    hideSpinner();
    isLoadingMore = false;
    updateLoadMoreButtonState();
  }
}

async function loadMoreProducts() {
  return runLoad(getBatchSize());
}

async function ensureInitialBatchSize() {
  if (!productsOnPage) return;

  const initialTarget = getInitialBatchSize();
  const currentVisible = getVisibleCardCount();
  const missing = initialTarget - currentVisible;

  if (missing > 0) {
    await runLoad(missing);
  } else {
    updateLoadMoreButtonState();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureInitialBatchSize);
} else {
  ensureInitialBatchSize();
}
